import * as yup from "yup";

const emailYup = yup
  .string()
  .trim()
  .lowercase()
  .required("Email is required")
  .email("Email must be a valid email");

const passwordYup = yup
  .string()
  .required("Password is required");

const recaptchaYup = yup
  .string()
  .required("Captcha is required");

const optionalRecaptchaYup = yup
  .string()
  .optional();

const phoneYup = yup.string()
  .required("Mobile number is required")
  .min(12, "Please enter a valid mobile number");

export const SignInFormSchema = yup.object({
  email: emailYup,
  password: passwordYup,
  recaptcha: recaptchaYup,
});

export const SignInFormOptionalRecaptchaSchema = yup.object({
  email: emailYup,
  password: passwordYup,
  recaptcha: optionalRecaptchaYup,
});

export const SignInEmailSchema = yup.object({
  email: emailYup,
});

export const SignInPhonesSchema = yup.object({
  phone: phoneYup,
});

export const SignInPasswordSchema = yup.object({
  password: passwordYup,
  recaptcha: recaptchaYup,
});

export const TestingSignInPasswordSchema = yup.object({
  password: passwordYup,
  recaptcha: optionalRecaptchaYup,
});

export type SignInEmailFormType = yup.InferType<typeof SignInEmailSchema>;
export type SignInPasswordFormType = yup.InferType<typeof SignInPasswordSchema>;
export type SignInFormType = yup.InferType<typeof SignInFormSchema>;
export type SignInOptimalReCaptchaFormType = yup.InferType<typeof SignInFormOptionalRecaptchaSchema>;
export type SignInPhoneSchemaFormType = yup.InferType<typeof SignInPhonesSchema>;
